module.exports = __webpack_public_path__ + "static/media/contact.7fda5d6c.svg";